<template>
  <div class="cert-header d-flex py-5">
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
      <div class="cert-title cert-large">GuideLines</div>
    </div>
  </div>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
    <div v-for="(item,index) in items" :key="index" :ref="`i${index}`">
      <cert-law-container :title="item.title"
                          :description="item.description"
                          :url="item.url"
                          :path="item.path"
                          :button-text="item.buttonText"
                          :separator="index!==items.length-1"
                          :pre-download="item.preDownload"/>
    </div>
  </div>
</template>

<script>
import CertLawContainer from "./components/CertLawContainer"

export default {
  name: "GuideLines",
  components: {
    CertLawContainer
  },
  data() {
    return {
      items: [
        {
          title: "Cyber Incident Reporting Guide",
          description: "A guide designed to answer questions about cyber incident reporting",
          path: "/guide/incident",
          buttonText: "View More",
          preDownload: false
        },
        {
          title: "Directives on Cyber security for Network and Information Systems",
          description: "Documentation on guidelines for securing ICT infrastructure and information",
          url: `cyber.gov.rw/index.php?eID=dumpFile&t=f&f=71&token=54b28bf5e34ee83ebe916e7f7045139e05564354`,
          preDownload: false
        },
        {
          title: "Guidelines for Internet Resources Management and Allocation",
          description: "Guidelines for internet resources management and allocation in general, and \".rw\" domain in particular",
          url: `${process.env.VUE_APP_BASE_URL}file/guidelines_for_internet_resources.pdf`,
          preDownload: true
        },
        {
          title: "RINEX Management Guidelines",
          description: "Rwanda Internet Exchange Point (RINEX) management guidelines",
          url: `${process.env.VUE_APP_BASE_URL}file/guidelines_rinex.pdf`,
          preDownload: true
        },
        {
          title: "Interconnection Guidelines",
          description: "Interconnection guidelines",
          url: `${process.env.VUE_APP_BASE_URL}file/guidlines_interconnect.pdf`,
          preDownload: true
        },
      ],
    };
  },

  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
    for (let i = 0; i < this.items.length; i++)
      this.$anim.fadeInBottom(this.$refs[`i${i}`], 50 * i);
  }
}
</script>